import React, { useState, useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import './VolunteerAttempts.css'
import LoadingScreen from '../components/LoadingScreen'

const VolunteerAttempts = () => {
  const history = useHistory()
  const location = useLocation()
  const [attempts, setAttempts] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')
  const [testFilter, setTestFilter] = useState('')

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const testId = params.get('test_id')
    if (testId) {
      setTestFilter(testId)
    }
    fetchAttempts()
  }, [location])

  const fetchAttempts = async () => {
    try {
      const token = localStorage.getItem('access_token')
      let url = '/api/volunteer/test-attempts'
      if (testFilter) {
        url += `?test_id=${testFilter}`
      }

      const response = await fetch(url, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      })

      if (response.ok) {
        const data = await response.json()
        setAttempts(data.attempts || [])
      } else {
        setError('Failed to load attempts')
      }
    } catch (err) {
      setError('Network error')
    } finally {
      setLoading(false)
    }
  }

  if (loading) {
    return <LoadingScreen message="Loading Attempts" />
  }

  return (
    <div className="volunteer-attempts-container">
      <header className="page-header">
        <h1>Test Attempts</h1>
        <button onClick={() => history.push('/volunteer-dashboard')}>← Back</button>
      </header>

      <main className="attempts-main">
        {error && <div className="error-message">{error}</div>}

        <div className="attempts-list">
          {attempts.length > 0 ? (
            attempts.map((attempt) => (
              <div key={attempt.id} className="attempt-card">
                <div className="attempt-header">
                  <h3>{attempt.test_title}</h3>
                  <span className={`status-badge status-${attempt.status}`}>{attempt.status}</span>
                </div>
                <p><strong>Student:</strong> {attempt.student_name}</p>
                <p><strong>Score:</strong> {attempt.percentage}%</p>
                <p><strong>Date:</strong> {new Date(attempt.created_at).toLocaleString()}</p>
                <button
                  className="view-button"
                  onClick={() => history.push(`/volunteer/attempt/${attempt.id}`)}
                >
                  View Details
                </button>
              </div>
            ))
          ) : (
            <p className="no-attempts">No attempts found</p>
          )}
        </div>
      </main>
    </div>
  )
}

export default VolunteerAttempts

